

import React, { memo } from 'react';

import '../styles/_player-common-view.scss';







const PlayerCommonView = ({
  selectedCaption,
  source,
  setVideoRef
}) =>
// eslint-disable-next-line jsx-a11y/media-has-caption
<video
  className="player-common-view"
  ref={setVideoRef}
  src={source}
  crossOrigin="anonymous">

    {
  selectedCaption && selectedCaption.sourceUrl ?
  <track kind="subtitles" src={selectedCaption.sourceUrl} default /> :
  null}

  </video>;


export default memo(PlayerCommonView);